const state = () => ({
  userConfig: null,
});

const actions = {
  async fetchUserConfig({ state: currentState, commit }) {
    if (currentState.userConfig) return;
    try {
      const { data } = await this.$api.get(this.getters.getApiLink('resumeBuilder.config'));
      commit('setUserConfig', data);
      return data;
    } catch (e) {
      throw new Error('Something went wrong' + e);
    }
  },
};

const mutations = {
  setUserConfig(currentState, newValue) {
    currentState.userConfig = newValue;
  },
};

const getters = {
  userConfig: (s) => s.userConfig,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
